import { Base } from "@studiometa/js-toolkit";
class EditorVisibility extends Base {
  /**
   * Config.
   */
  static config = {
    name: "EditorVisibility"
  };
  /**
   * The content type this editor edits, read from the markup.
   *
   * The coordinator uses it to tell the three editors apart. It is a DOM fact,
   * so it answers before anything mounts.
   */
  get lang() {
    return this.$el.dataset.lang ?? "";
  }
  show() {
    this.$write(() => {
      this.$el.style.display = "";
    });
  }
  hide() {
    this.$write(() => {
      this.$el.style.display = "none";
    });
  }
  toggle(force) {
    if (force === true) {
      this.show();
      return;
    }
    if (force === false) {
      this.hide();
      return;
    }
    this.$read(() => {
      if (this.$el.style.display === "none") {
        this.show();
      } else {
        this.hide();
      }
    });
  }
}
export {
  EditorVisibility as default
};
//# sourceMappingURL=EditorVisibility.js.map
